import { OutboundEmailListItemWidget } from "./OutboundEmailListItemWidget";
import { useState } from "react";
import { OutboundEmail } from "@zickko/shared";

type Props = {
  emailList: OutboundEmail[];
  onSelectEmail: (email) => void;
};

export const OutboundEmailListWidget = (props: Props) => {
  return (
    <div className="list-container">
      {props.emailList.length === 0 ? (
        <div className="no-emails-message">No emails available.</div>
      ) : (
        props.emailList.map((email) => (
          <OutboundEmailListItemWidget email={email} key={email.id} onSelectEmail={() => props.onSelectEmail(email)} />
        ))
      )}
    </div>
  );
};
